if (!customElements.get('product-sticky-content')) {
    class StickMobileControl extends HTMLElement {
        stickyDiv = document.createElement("dialog");
        isShow = false;
        constructor() {
            super()
        }
        onScrollEvt = this.onScroll.bind(this)
        connectedCallback() {
            this.getStickyDiv();

            window.addEventListener("scroll", this.onScrollEvt)
        }
        disconnectedCallback() {
            window.removeEventListener("scroll", this.onScrollEvt)

        }
        onScroll() {
            if (document.documentElement.scrollTop >= 136 && this.isShow == false) {
                this.showFixed()
            }

            if (document.documentElement.scrollTop < 136 && this.isShow == true) {
                this.hideFixed()
            }

            if (document.documentElement.scrollTop >= 1500 && this.isShow == true) {
                this.hideFixed()
            }
        }
        showFixed() {

            document.getElementById("sticky-div-followWrap").style.minHeight = this.getDivHeight() + "px";
            this.stickyDiv.classList.add("stickyDiv-fixed");
            this.isShow = true;
            // document.getElementById("sticky-div-mobile-temp").style.height = this.stickyDiv.offsetHeight + "px"
        }
        hideFixed() {
            this.stickyDiv.classList.remove("stickyDiv-fixed")
            this.isShow = false;
            // document.getElementById("sticky-div-followWrap").style.height = this.stickyDiv.offsetHeight + "px";
        }

        getStickyDiv() {
            this.stickyDiv = document.getElementById("sticky-div-mobile");
            document.getElementById("sticky-div-followWrap").style.minHeight = this.getDivHeight() + "px";

        }

        getDivHeight() {
            var elemRect = this.stickyDiv.getBoundingClientRect();
            if (elemRect.height < 400) {
                return 400;
            }
            return elemRect.height
        }
    }

    customElements.define('product-sticky-content', StickMobileControl)
}
